import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebFormFieldModule } from '../../components/web-form-field/web-form-field.module';
import { WebButtonModule } from '../../components/web-button/web-button.module';
import { TermsModule } from '../../components/terms/terms.module';

import { CheckoutComponent } from './checkout.component';

@NgModule({
  declarations: [
    CheckoutComponent
  ],
  imports: [
    CommonModule,
        FormsModule,
        ReactiveFormsModule,
        WebFormFieldModule,
        WebButtonModule,
        TermsModule,
  ],
  exports: [
    CheckoutComponent
  ]
})
export class CheckoutModule { }


